import { isError } from 'lodash';

export const isHttpSuccess = (response) => {
  let codeNumber = response;
  if (typeof codeNumber === 'object') {
    codeNumber = response.status;
  }
  return isError(response) || (codeNumber > 199 && codeNumber < 300);
};
